export default "__VITE_ASSET__jThjpL3b__"